import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { PopoverButton as n } from "@headlessui/react";
import { Button as t } from "../Button/index.js";
import a from "dayjs";
import { ChevronLeftIcon as s } from "../Icons/basic/ChevronLeftIcon.js";
import { ChevronRightIcon as f } from "../Icons/basic/ChevronRightIcon.js";
const b = ({
  value: e,
  format: r = "MMMM YYYY",
  onLeftArrowClick: i,
  onRightArrowClick: l
}) => /* @__PURE__ */ m("div", { className: "jm-relative jm-flex jm-w-fit jm-items-center jm-gap-1", children: [
  /* @__PURE__ */ o(
    t,
    {
      label: "arrowLeft",
      withTooltip: !1,
      icon: /* @__PURE__ */ o(s, {}),
      variant: "ghost",
      full: !1,
      onClick: i
    }
  ),
  /* @__PURE__ */ o(n, { className: "jm-w-[209px] jm-border-none jm-bg-white jm-p-0 jm-text-jutro-new-blue-700 focus:jm-border-none focus:jm-outline-none disabled:jm-bg-transparent", children: /* @__PURE__ */ o(
    t,
    {
      text: a(e).locale("pl").format(r),
      variant: "ghost",
      size: "regular"
    }
  ) }),
  /* @__PURE__ */ o(
    t,
    {
      label: "arrowRight",
      withTooltip: !1,
      icon: /* @__PURE__ */ o(f, {}),
      variant: "ghost",
      full: !1,
      onClick: l
    }
  )
] });
export {
  b as Buttons
};
//# sourceMappingURL=Buttons.js.map
